// src/pages/plantation/formula/hitung-umur.js
/**
 * Fungsi untuk menghitung umur dalam bulan dengan 2 desimal
 * Sama persis dengan formula Excel: =(tanggal_closing - tanggal_mulai)/30
 * Jika tidak ada tanggal closing, gunakan tanggal saat ini
 */
export const calculateUmur = (idLokasi, mulaiRawat, hasilPanenData) => {
    try {
        // Validasi input
        if (!idLokasi || !mulaiRawat || mulaiRawat === '-') {
            console.log(`[calculateUmur] Input tidak valid - ID: ${idLokasi}, Mulai: ${mulaiRawat}`);
            return null;
        }

        // Konversi tanggal mulai rawat ke format Date
        let mulaiRawatDate = parseDateToDateObject(mulaiRawat);
        
        if (!mulaiRawatDate || isNaN(mulaiRawatDate.getTime())) {
            console.log(`[calculateUmur] Gagal parse tanggal mulai - ${mulaiRawat}`);
            return null;
        }

        console.log(`[calculateUmur] Mencari tanggal closing untuk ID: ${idLokasi}`);
        console.log(`[calculateUmur] Mulai rawat: ${mulaiRawat}`);
        
        // Cari data hasil panen dengan id_lokasi yang sama
        let targetDate = null;
        let foundClosing = false;
        
        if (hasilPanenData && typeof hasilPanenData === 'object') {
            console.log(`[calculateUmur] hasilPanenData tersedia, type: ${typeof hasilPanenData}`);
            console.log(`[calculateUmur] Keys: ${Object.keys(hasilPanenData).length}`);
            
            // Loop melalui semua record
            for (const key in hasilPanenData) {
                const record = hasilPanenData[key];
                
                if (!record) continue;
                
                const recordId = record.id_lokasi ? record.id_lokasi.toString() : null;
                const searchId = idLokasi.toString();
                
                // Debug detil untuk beberapa record pertama
                if (Object.keys(hasilPanenData).indexOf(key) < 5) {
                    console.log(`[calculateUmur] Record ${key}: id=${recordId}, closing=${record.tanggal_closing || 'kosong'}`);
                }
                
                if (recordId === searchId) {
                    console.log(`[calculateUmur] MATCH ditemukan untuk ID: ${searchId}`);
                    console.log(`[calculateUmur] Record data:`, record);
                    
                    if (record.tanggal_closing && 
                        record.tanggal_closing.trim() !== '' && 
                        record.tanggal_closing !== '-') {
                        
                        console.log(`[calculateUmur] Tanggal closing ditemukan: "${record.tanggal_closing}"`);
                        
                        const closingDate = parseDateToDateObject(record.tanggal_closing);
                        
                        if (closingDate && !isNaN(closingDate.getTime())) {
                            targetDate = closingDate;
                            foundClosing = true;
                            console.log(`[calculateUmur] Berhasil parse tanggal closing: ${closingDate.toLocaleDateString()}`);
                            break; // Keluar loop setelah ditemukan
                        } else {
                            console.log(`[calculateUmur] Gagal parse tanggal closing: ${record.tanggal_closing}`);
                        }
                    } else {
                        console.log(`[calculateUmur] Tanggal closing kosong atau '-'`);
                    }
                }
            }
        } else {
            console.log(`[calculateUmur] hasilPanenData tidak tersedia atau bukan object:`, hasilPanenData);
        }

        // Jika tidak ada tanggal closing, gunakan tanggal sekarang
        if (!foundClosing) {
            targetDate = new Date();
            console.log(`[calculateUmur] Tidak ditemukan tanggal closing, menggunakan tanggal sekarang: ${targetDate.toLocaleDateString()}`);
        } else {
            console.log(`[calculateUmur] Menggunakan tanggal closing: ${targetDate.toLocaleDateString()}`);
        }

        // PERHITUNGAN SAMA PERSIS DENGAN EXCEL:
        // =(tanggal_target - tanggal_mulai) / 30
        
        // Hitung selisih dalam milidetik
        const diffMs = targetDate.getTime() - mulaiRawatDate.getTime();
        
        // Konversi ke hari (sama seperti Excel)
        const diffDays = diffMs / (1000 * 60 * 60 * 24);
        
        // Bagi dengan 30 (sama seperti Excel)
        const umurDecimal = diffDays / 30;
        
        // Bulatkan ke 2 desimal untuk ditampilkan
        const umur2Desimal = Math.round(umurDecimal * 100) / 100;
        
        console.log(`[calculateUmur] HASIL - ID: ${idLokasi}, ` +
                   `Mulai: ${mulaiRawatDate.toLocaleDateString()}, ` +
                   `Target: ${targetDate.toLocaleDateString()}, ` +
                   `Hari: ${diffDays.toFixed(2)}, ` +
                   `Umur: ${umur2Desimal} bulan`);
        
        return Math.max(0, umur2Desimal);
        
    } catch (error) {
        console.error('[calculateUmur] Error:', error);
        return null;
    }
};

/**
 * Helper function untuk parsing tanggal dari berbagai format ke Date object
 */
const parseDateToDateObject = (dateString) => {
    if (!dateString) {
        return null;
    }
    
    // Normalisasi: hapus spasi di awal/akhir
    const normalized = dateString.toString().trim();
    
    console.log(`[parseDateToDateObject] Parsing: "${dateString}" -> "${normalized}"`);
    
    // Format DD-MM-YYYY (format Firebase)
    if (normalized.includes('-') && normalized.split('-').length === 3) {
        const parts = normalized.split('-');
        
        // Format DD-MM-YYYY
        if (parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4) {
            const date = new Date(
                parseInt(parts[2]), // Tahun
                parseInt(parts[1]) - 1, // Bulan (0-based)
                parseInt(parts[0]), // Tanggal
                0, 0, 0, 0
            );
            console.log(`[parseDateToDateObject] Parsed DD-MM-YYYY: ${date.toLocaleDateString()}`);
            return date;
        }
        // Format YYYY-MM-DD
        else if (parts[0].length === 4 && parts[1].length === 2 && parts[2].length === 2) {
            const date = new Date(
                parseInt(parts[0]), // Tahun
                parseInt(parts[1]) - 1, // Bulan (0-based)
                parseInt(parts[2]), // Tanggal
                0, 0, 0, 0
            );
            console.log(`[parseDateToDateObject] Parsed YYYY-MM-DD: ${date.toLocaleDateString()}`);
            return date;
        }
    }
    
    // Format DD/MM/YYYY
    if (normalized.includes('/') && normalized.split('/').length === 3) {
        const parts = normalized.split('/');
        
        if (parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4) {
            const date = new Date(
                parseInt(parts[2]), // Tahun
                parseInt(parts[1]) - 1, // Bulan (0-based)
                parseInt(parts[0]), // Tanggal
                0, 0, 0, 0
            );
            console.log(`[parseDateToDateObject] Parsed DD/MM/YYYY: ${date.toLocaleDateString()}`);
            return date;
        }
    }
    
    // Coba parse sebagai Date object
    try {
        const date = new Date(normalized);
        if (!isNaN(date.getTime())) {
            // Set waktu ke 00:00:00 untuk konsistensi
            date.setHours(0, 0, 0, 0);
            console.log(`[parseDateToDateObject] Parsed dengan Date constructor: ${date.toLocaleDateString()}`);
            return date;
        }
    } catch (e) {
        console.warn(`[parseDateToDateObject] Gagal parse dengan Date constructor: ${normalized}`);
    }
    
    console.log(`[parseDateToDateObject] Format tidak dikenali: ${normalized}`);
    return null;
};